import { css } from 'styled-components';
export default {
    nimbusSans: {
        light: css `
      font-family: 'Nimbus Sans', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        regular: css `
      font-family: 'Nimbus Sans', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'Nimbus Sans', sans-serif;
      font-weight: 400;
      font-style: italic;
    `,
        bold: css `
      font-family: 'Nimbus Sans', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        black: css `
      font-family: 'Nimbus Sans', sans-serif;
      font-style: normal;
      font-weight: 900;
    `,
    },
    agBook: {
        light: css `
      font-family: 'ag-book', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        regular: css `
      font-family: 'ag-book', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        regularItalic: css `
      font-family: 'ag-book', sans-serif;
      font-style: italic;
    `,
        bold: css `
      font-family: 'ag-book', sans-serif;
      font-weight: 700;
      font-style: normal;
    `,
    },
};
